import * as React from 'react'
import CloseIcon from './assets/close'
import { useOffsetContainerCtx } from './OffsetContainer'
import { cn } from './cn'
import CloseBig from './assets/close-big'

const CloseButton = ({
  close,
  isInputFocused,
}: {
  close: () => void
  isInputFocused: boolean
}) => {
  const isTouched = useOffsetContainerCtx(s => s.isTouched)
  const device = useOffsetContainerCtx(s => s.device)

  if (device === 'default' && isTouched) {
    return (
      <>
        <div
          className={cn(
            'sp-h-[54px] sp-flex sp-w-full sp-items-center sp-justify-end sp-bg-survey-background sp-fixed sp-top-0 sp-left-0 sp-z-50 sp-px-[15px]',
            {
              hidden: isInputFocused,
            }
          )}>
          <button
            className="sp-bg-survey-background sp-text-survey-text-placeholder hover:sp-text-survey-text-user sp-transition-colors"
            onClick={e => {
              e.stopPropagation()
              close()
            }}>
            <CloseBig width={24} />
          </button>
        </div>
        <div className="sp-min-h-[54px] sp-bg-survey-background sp-w-full" />
      </>
    )
  }

  return (
    <button
      className="sp-absolute sp-right-[-9px] sp-top-[-11px] sp-bg-survey-background sp-rounded-[50%] sp-shadow-survey-shadow sp-text-survey-text-placeholder hover:sp-text-survey-text-user sp-transition-colors sp-z-50"
      onClick={e => {
        e.stopPropagation()
        close()
      }}>
      <CloseIcon width={24} />
    </button>
  )
}

export default CloseButton
